//Global variables
var $newsletterPop = $('.NewsletterPopup');
$(function(){
  if ($('#jsc-phone').length > 0) {
    initTelJS();
  }
  initDate();
  stickyATCHeader();
  initSelect();
  getSessionRegister();
  // $(document).on('contextmenu', 'img', function() {
  //     return false;
  // });
  var $isGiftCard = $('#jsc-gift-card').val() == 'true';
  if (!$isGiftCard) {
    variantAvailable($('.ColorSwatch__Radio:checked').val());
    varotherAvai($('.SizeSwatch__Radio:checked').val());
    variantAvailablenosize($('.ColorSwatch__Radio:checked').val());
    varsecotherAvai($('.SizeSwatch__Radio:checked').val());
  }
  onloadGetProductImgArray();

});

checkSubscribeTerms = () =>{
  event.preventDefault();
  var $eleCaptcha = $newsletterPop.find('#g-recaptcha')
  var $inputEmail = $('#pop-subscribe_email').val();
  var $errorMessage = $('#terms-error-message');
  var $errorcaptcha = $('#terms-error-message');

    if (($('#subscribe-agree-box').is(':checked')) && ($inputEmail != null)) {
    //  $('.wrapperSubscribe-agree-box').hide();
    //  $('#jsc-subscribe_button').hide();
    //  $('#submit-Captcha_button').show();
    //  $eleCaptcha.show();
      $errorMessage.hide();
      $errorcaptcha.hide();
    }else {
      $errorMessage.show();
      $errorcaptcha.show();
    }

}

captchaCallback = (response) =>{
  submitSubscribeForm(response);
}

submitSubscribeForm = (response) =>{
  event.preventDefault();

  var $_email = $('#pop-subscribe_email').val();
  var $_popEle = $('#newsletter-popup');
  var $_popEleChild = $_popEle.children();

    if(response != null && $('#subscribe-agree-box').is(':checked') && $('#pop-subscribe_email').val() != null && $('#pop-subscribe_email').val() != '') {
      console.log(response);
      $.ajax({
        url: "/contact#newsletter-popup",
        type: "POST",
        data: $_email,
        success: function (response){
          $('#jsc-Captcha-Alert_success').show();
          $('#pop-subscribe_email').hide();
          $('#submit-Captcha_button').hide();
          $('#g-recaptcha').hide();
          $('.wrapperSubscribe-agree-box').hide();
          $('#jsc-subscribe_button').hide();
          $('#terms-error-message').hide();
          $('#captcha-error-message').hide();
        },
        error: function(response) {
          // console.log('error subscirbe',response);
        }
      });
    }else {
      $('#terms-error-message').show();
      $('#captcha-error-message').show();
    }
}
openSubscribeForm = () =>{
  $('.NewsletterPopup').attr('aria-hidden','false');
}

validateSubscribeForm = () =>{
  event.preventDefault();
  var $_email = $('#pop-subscribe_email').val();
  var $_popEle = $('#newsletter-popup');
  var $_popEleChild = $_popEle.children();

  var response = grecaptcha.getResponse();
  if (response.length != 0 && $('#subscribe-agree-box').is(':checked') && $('#pop-subscribe_email').val() != null && $('#pop-subscribe_email').val() != '') {
    $.ajax({
      url: "/contact#newsletter-popup",
      type: "POST",
      data: $_email,
      success: function (response){
        $('#jsc-Captcha-Alert_success').show();
        $('#pop-subscribe_email').hide();
        $('#submit-Captcha_button').hide();
        $('#g-recaptcha').hide();
        $('.wrapperSubscribe-agree-box').hide();
        $('#jsc-subscribe_button').hide();
        $('#terms-error-message').hide();
        $('#captcha-error-message').hide();
      },
      error: function(response) {
        // console.log('error subscirbe',response);
      }
    });
  }else {
    $('#terms-error-message').show();
    $('#captcha-error-message').show();
  }
}

variantAvailable = ($color) =>{
  // variable
  var $hideSelect = $('.jsc-hidden-variant');
  var $obj = {};
  var $Swatch = $('.jsc-swatch');
  var $otherSwatch = $('.jsc-other-swatch');
  var $_loop = 0;

  $Swatch.addClass('hide');
  $Swatch.children('.SizeSwatch').removeClass('jsc-otherclick');

  $hideSelect.children().each(function(){
    var $_this = $(this);
    var $_variantTitle = $_this.attr('data-title');

    if ($_variantTitle.includes($color)) {
      var $_formating = $_variantTitle.replace($color, '').replace(' / ', '');
      // hide variant swatch
      $Swatch.each(function(){
        var $_this = $(this);
        var $_value = $_this.attr('data-value');
        var $_format = $color.concat(' / ').concat($_value);

        if ($_variantTitle.includes($_format)) {
          $_this.removeClass('hide');
          $_loop = $_loop + 1;
          if ($_loop == 1) {
              $_this.children('.SizeSwatch').addClass('jsc-otherclick');
          }
        }
      });
    }
  });

  setTimeout(function(){
    $('label.jsc-otherclick').click();
  },10);

//  setTimeout(function(){
//  varotherAvai($('.SizeSwatch__Radio:checked').val());
//},600);

}

variantAvailablenosize = ($color) =>{
  // variable
  var $hideSelect = $('.jsc-hidden-variant');
  var $obj = {};
  var $otherSwatch = $('.jsc-other-swatch');
  var $_loop = 0;

  $otherSwatch.addClass('hide');
  $otherSwatch.children('.SizeSwatch').removeClass('jsc-click');

  $hideSelect.children().each(function(){
    var $_this = $(this);
    var $_variantTitle = $_this.attr('data-title');

    if ($_variantTitle.includes($color)) {
      $otherSwatch.each(function(){
        var $_otherthis = $(this);
        var $_othervalue = $_otherthis.attr('data-value');
        var $_format = $color.concat(' / ').concat($_othervalue);

        if ($_variantTitle.includes($_format)) {
          $_otherthis.removeClass('hide');
          $_loop = $_loop + 1;
          if ($_loop == 1) {
          $_otherthis.children('.SizeSwatch').addClass('jsc-click');
          }
        }
      });
    }
  });

  setTimeout(function(){
    $('label.jsc-click').click();
  },10);

//  setTimeout(function(){
//  varotherAvai($('.SizeSwatch__Radio:checked').val());
//},600);

}

varsecotherAvai = ($othervariant) =>{
  var $hideSelect = $('.jsc-hidden-variant');
  var $Swatch = $('.ColorSwatch__Radio:checked');
  var $otherSwatch = $('.jsc-other-swatch');
  var $_loop = 0;

//  $otherSwatch.addClass('hide');
  $otherSwatch.children('.SizeSwatch').removeClass('jsc-secclick');

  $hideSelect.children().each(function(){
    var $_this = $(this);
    var $_variantTitle = $_this.attr('data-title');
//    setTimeout(function(){
        var $_colorvalue = $Swatch.val();
        if ($_variantTitle.includes($_colorvalue)) {
          if ($_variantTitle.includes($othervariant)) {
            $otherSwatch.each(function(){
              var $_otherthis = $(this);
              var $_othervalue = $_otherthis.attr('data-value');
              var $_format = $_colorvalue.concat(' / ').concat($othervariant).concat(' / ').concat($_othervalue);
              if ($_variantTitle.includes($_format)) {
                $_otherthis.removeClass('hide');
                $_loop = $_loop + 1;
                if ($_loop == 1) {
                $_otherthis.children('.SizeSwatch').addClass('jsc-secclick');
                }
              }
            });
          }
        }
//      },10);
  });

  setTimeout(function(){
    $('label.jsc-secclick').click();
  },15);

}

varotherAvai = ($size) =>{
  var $hideSelect = $('.jsc-hidden-variant');
  var $Swatch = $('.ColorSwatch__Radio:checked');
  var $otherSwatch = $('.jsc-other-swatch');
  var $_loop = 0;

  $otherSwatch.addClass('hide');
  $otherSwatch.children('.SizeSwatch').removeClass('jsc-click');

  $hideSelect.children().each(function(){
    var $_this = $(this);
    var $_variantTitle = $_this.attr('data-title');
//    setTimeout(function(){
        var $_colorvalue = $Swatch.val();
        if ($_variantTitle.includes($_colorvalue)) {
          if ($_variantTitle.includes($size)) {
            $otherSwatch.each(function(){
              var $_otherthis = $(this);
              var $_othervalue = $_otherthis.attr('data-value');
              var $_format = $_colorvalue.concat(' / ').concat($size).concat(' / ').concat($_othervalue);

              if ($_variantTitle.includes($_format)) {
                $_otherthis.removeClass('hide');
                $_loop = $_loop + 1;
                if ($_loop == 1) {
                $_otherthis.children('.SizeSwatch').addClass('jsc-click');
                }
              }
            });
          }
        }
//      },10);
  });

  setTimeout(function(){
    $('label.jsc-click').click();
  },15);

}

//start of display variant img
var $imgContainer = $('.Product__Slideshow');
var $childArrayElement = $imgContainer.find('.Carousel__Cell');
var $navContainer = $('.selectedNav');
var $navCell = $('.navCell');

onloadGetProductImgArray = () =>{
  var $isShow = false;
  var $childArray = $imgContainer.children();
  var $flickityConfig = $imgContainer.attr('data-flickity-config');
  var $obj = JSON.parse($flickityConfig);
  var $selectedColor = $('.ColorSwatch__Radio:checked').val();
  var $navContainer = $('.selectedNav');
  var $navCell = $('.navCell');
  var $producttitle = $('.ProductMeta__Title.Heading.u-h2').attr('data-title');
  var $productvarSKU = $('.jsc-hidden-variant').find(':selected').attr('data-sku');

  setTimeout(function(){
  if ($('.jsc-other-swatch').find(':checked').val() != undefined) {
      var $varcolor = $('.jsc-other-swatch').find(':checked').val();
      var $_format = $selectedColor.concat('-').concat($varcolor);
  }
  if ($('.jsc-swatch').find(':checked').val() != undefined) {
      var $varsize = $('.jsc-swatch').find(':checked').val();
      var $_secformat = $selectedColor.concat('-').concat($varsize);
      console.log($_secformat);
  }

  // Destroy slider
  destroyProductSlider();
  destroyNavSlider();

  // remove all product image
  $imgContainer.children().remove();
  $navCell.remove();

  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = $($childArrayElement[i]).attr('data-img-alt');
    if ($thisAltText == $_format) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $_secformat) {
      console.log($_secformat);
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $producttitle) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $selectedColor) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $productvarSKU) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }
  }
  for (var i = 0; i < $navCell.length; i++) {
    var $thisAltText = $($navCell[i]).attr('data-img-alt');
    if ($thisAltText == $_format) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $_secformat) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $producttitle) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $selectedColor) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $productvarSKU) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }
  }
  initProductSlider($isShow,$obj);
  initNavSlider();
},100);
}

variantImageSwap = (evt,color) =>{
  var $this = $(evt);
  var $isShow = false;
  var $flickityConfig = $imgContainer.attr('data-flickity-config');
  var $obj = JSON.parse($flickityConfig);
  var $producttitle = $('.ProductMeta__Title.Heading.u-h2').attr('data-title');
setTimeout(function(){
  var $productvarSKU = $('.jsc-hidden-variant').find(':selected').attr('data-sku');
  if ($('.jsc-other-swatch').find(':checked').val() != undefined) {
      var $varcolor = $('.jsc-other-swatch').find(':checked').val();
      var $_format = color.concat('-').concat($varcolor);
      console.log($_format);
  }
  if ($('.jsc-swatch').find(':checked').val() != undefined) {
      var $varsize = $('.jsc-swatch').find(':checked').val();
      var $_secformat = color.concat('-').concat($varsize);
      console.log($_secformat);
  }

  // Destroy slider
  destroyProductSlider();
  destroyNavSlider();

  // remove all slider image
  $imgContainer.children().remove();
  $navCell.remove();

  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = $($childArrayElement[i]).attr('data-img-alt');
    if ($thisAltText == $_format) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $_secformat) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $producttitle) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == color) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $productvarSKU) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }
  }
  for (var i = 0; i < $navCell.length; i++) {
    var $thisAltText = $($navCell[i]).attr('data-img-alt');
    if ($thisAltText == $_format) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $_secformat) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $producttitle) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == color) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $productvarSKU) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }
  }
  initProductSlider($isShow,$obj);
  initNavSlider();
},500);
}

variantImageSecSwap = (evt,value) =>{
  var $this = $(evt);
  var $isShow = false;
  var $flickityConfig = $imgContainer.attr('data-flickity-config');
  var $obj = JSON.parse($flickityConfig);
  setTimeout(function(){
  var $producttitle = $('.ProductMeta__Title.Heading.u-h2').attr('data-title');
  var $varcolor = $('.jsc-color-swatch').find(':checked').val();
  var $_format = $varcolor.concat('-').concat(value);


  // Destroy slider
  destroyProductSlider();
  destroyNavSlider();

  // remove all slider image
  $imgContainer.children().remove();
  $navCell.remove();

  var $productvarSKU = $('.jsc-hidden-variant').find(':selected').attr('data-sku');
  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = $($childArrayElement[i]).attr('data-img-alt');
    if ($thisAltText == $_format) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $varcolor) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }else if ($thisAltText == $productvarSKU) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }
  }
  for (var i = 0; i < $navCell.length; i++) {
    var $thisAltText = $($navCell[i]).attr('data-img-alt');
    if ($thisAltText == $_format) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $varcolor) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }else if ($thisAltText == $productvarSKU) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }
  }
  initProductSlider($isShow,$obj);
  initNavSlider();
},500);

}

initNavSlider = () =>{
  var $_navCell = $('.navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {prevNextButtons: true,pageDots: false,arrowShape: {x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25},cellAlign: 'center',wrapAround: true}

  if ($(window).width() > 481) {
    if ($cellLength > 6) {
      $('.selectedNav').flickity($_flickityObj);
    }
  } else {
    if ($cellLength > 3) {
      $('.selectedNav').flickity($_flickityObj);
    }
  }
}

initProductSlider = (isShow,obj) =>{
  if (isShow) {
    $imgContainer.flickity(obj);

    // Flickity instance
    var flkty = $imgContainer.data('flickity');
    // elements
    var $cellButtonGroup = $('.selectedNav');
    var $cellButtons = $cellButtonGroup.find('.navCell');

    // update selected cellButtons
    $imgContainer.on( 'select.flickity', function() {
      $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
      $cellButtons.eq( flkty.selectedIndex )
        .addClass('is-selected');
    });

    // select cell on button click
    $cellButtonGroup.on( 'click', '.navCell', function() {
      var index = $(this).index();
      $imgContainer.flickity( 'select', index );
    });
    // // previous
    // $('.button--previous').on( 'click', function() {
    //   $imgContainer.flickity('previous');
    // });
    // // next
    // $('.button--next').on( 'click', function() {
    //   $imgContainer.flickity('next');
    // });
  }
}

destroyProductSlider = () =>{
  $('.Product__Slideshow').flickity();
  $('.Product__Slideshow').flickity('destroy');
}

destroyNavSlider = () =>{
  $('.selectedNav').flickity();
  $('.selectedNav').flickity('destroy');
}

stickyATCHeader = () =>{
  if (location.href.includes('/products')) {
    var stickyimgTop = $('#shopify-section-product-recommendations').offset().top;
    var totaloffset = stickyimgTop - $('.Product__Gallery').height() - 200;
    if ($(window).width() < 481) {
      $(window).scroll(function() {
         var windowTop = $(window).scrollTop();
         console.log(windowTop);
         console.log(totaloffset);
         if (windowTop >= totaloffset) {
           $('.ProductForm__AddToCart').removeClass('jsc-sticky-bottom');
         } else {
           $('.ProductForm__AddToCart').addClass('jsc-sticky-bottom');
         }
       });
    }
  }
}

//shipping country img
function geotargetly_loaded(){
  var country_code = geotargetly_country_code().toLowerCase();
  var country_name = geotargetly_country_name();
  var flagClass = $('.jsc-flag-icon');
  var selectCountry = false;


  flagClass.each(function(){
    var countryCode = $(this).attr('data-country-code');
    if (countryCode == country_code) {
      var countryImg = $(this).val();
      var flagClassContainer = $('.jsc-shipping-country-wrap');
      flagClassContainer.children().remove();
      flagClassContainer.append('<img class="jsc-flag-img" src="'+countryImg+'" alt=""><span class="jsc-ship-text-pdp"> we ship to '+country_name+'!</span> ');
      selectCountry = true;
    }
  });

  if (selectCountry == false) {
    flagClass.each(function(){
      var countryCode = $(this).attr('data-country-code');
      if (countryCode == 'sg') {
        var countryImg = $(this).val();
        var flagClassContainer = $('.jsc-shipping-country-wrap');
        flagClassContainer.children().remove();
        flagClassContainer.append('<img class="jsc-flag-img" src="'+countryImg+'" alt=""><span class="jsc-ship-text-pdp"> we ship to Singapore !</span> ');
      }
    });
  }

}

jscChangeCountry = (e) =>{
  var $this = $(e);
  var $val = $this.val();
  var $birthday = $('#jsc-birthday').val();

  var $tags = `${$birthday},country_${$val},new_signup`;

  $('#jsc-customer-tag').val($tags)
}

initDate = () =>{
  var startDate = new Date(1900, 1 - 1, 1);
  var endDate = new Date(new Date().getFullYear() - 18, 12 - 1, 31);
  $('#jsc-birthday').datepicker({
    format: 'dd-mm-yyyy',
    startDate: startDate,
    endDate: endDate,
    startView: 2,
    maxViewMode: 2,
    disableTouchKeyboard: true,
    autoclose: true
  });

  $('#jsc-birthday').datepicker().on("changeDate", function(e) {
    var $birthday = $(this).val();
    var $country = $("#jsc-country").val();

    var $tags = `${$birthday},country_${$country},new_signup`;

    $('#jsc-customer-tag').val($tags)
  });
}

setSessionRegister = (e) =>{
  var $this = $(e);
  var $form = $this.parents('#create_customer');

  var $first_name = $form.find('input[name="customer[first_name]"]').val();
  var $last_name = $form.find('input[name="customer[last_name]"]').val();
  var $email = $form.find('input[name="customer[email]"]').val();
  var $birthday = $('#jsc-birthday').val();
  var $country = $('#jsc-country').val();

  console.log('okkkk',$this, $form);

  sessionStorage.setItem("first_name", $first_name);
  sessionStorage.setItem("last_name", $last_name);
  sessionStorage.setItem("email", $email);
  sessionStorage.setItem("birthday", $birthday);
  sessionStorage.setItem("country", $country);

    // $('#jsc-register-btn').click();

  // check registeration terms
  if ($('#jsc-reg-terms-btn').is(':checked')) {
      $('#jsc-register-btn').click();
      $('#jsc-reg-terms-error').hide();
  }else{
    $('#jsc-reg-terms-error').show();
  }

}

$("#jsc-reg-terms-btn").change(function() {
  if ($('#jsc-reg-terms-btn').is(':checked')) {
    $('#jsc-reg-terms-error').hide();
  }
});

getSessionRegister = () =>{

  var $form = $('#create_customer');
  var $first_name = $form.find('input[name="customer[first_name]"]');
  var $last_name = $form.find('input[name="customer[last_name]"]');
  var $email = $form.find('input[name="customer[email]"]');
  var $birthday = $('#jsc-birthday');
  var $country = $('#jsc-country');

  var $getFirstN = sessionStorage.getItem("first_name");
  var $getLastN = sessionStorage.getItem("last_name");
  var $getEmail = sessionStorage.getItem("email");
  var $getBirthday = sessionStorage.getItem("birthday");
  var $getCountry = sessionStorage.getItem("country");

  if ($getFirstN != 'undefined' && $getFirstN != 'null') {
    $first_name.val($getFirstN);
  }
  if ($getLastN != 'undefined' && $getLastN != 'null') {
    $last_name.val($getLastN);
  }
  if ($getEmail != 'undefined' && $getEmail != 'null') {
    $email.val($getEmail);
  }
  if ($getBirthday != 'undefined' && $getBirthday != 'null') {
    $birthday.val($getBirthday);
  }
  if ($getCountry != 'undefined' && $getCountry != 'null' && $getCountry != null) {
    $country.val($getCountry);
    $country.trigger('change');
  }

}

initSelect = () =>{
  $('#jsc-country').select2();
}

initTelJS = () =>{
  var $input = document.getElementById("jsc-phone");
  var iti = $("#jsc-phone").intlTelInput({
    allowExtensions: true,
    formatOnDisplay: true,
    autoFormat: true,
    autoHideDialCode: true,
    defaultCountry: "auto",
    preventInvalidNumbers: true,
    separateDialCode: true,
    geoIpLookup: function(callback) {
      $.get("http://ipinfo.io", function() {}, "jsonp").always(function(resp) {
        var countryCode = (resp && resp.country) ? resp.country : "";
        callback(countryCode);
      });
    },
     utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.9/js/utils.js"
  });


  $input.addEventListener("countrychange",function(e) {
    var $code = $('.iti__selected-dial-code').text();
    var $num = $('#jsc-phone').val();

    var $concat = $code + ' ' + $num;


    $('#jsc-hidden-phone').val($concat);

  });

}

concatePhone = () =>{
  setTimeout(function(){
    var $code = $('.iti__selected-dial-code').text();
    var $num = $('#jsc-phone').val();

    var $concat = $code + ' ' + $num;

    console.log('eee',$('#jsc-hidden-phone'), $concat);
    $('#jsc-hidden-phone').val($concat);
  },500);
}
